export default class DtoAquifer {
    constructor(obj) {
        this.id = obj.code
        this.name = obj.name
        this.margatCode = obj.margatCode
        this.code = obj.code
    }
}